/**
 * Admin Useraccount API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GroupDto } from './groupDto';
import { AccessDto } from './accessDto';


export interface UserDto { 
    id?: number;
    firstName?: string;
    lastName?: string;
    initials?: string;
    email?: string;
    group?: GroupDto;
    accessList?: Array<AccessDto>;
    companyCountry?: UserDto.CompanyCountryEnum;
}
export namespace UserDto {
    export const CompanyCountryEnum = {
        De: 'DE',
        Us: 'US'
    } as const;
    export type CompanyCountryEnum = typeof CompanyCountryEnum[keyof typeof CompanyCountryEnum];
}


export type CompanyCountryEnum = typeof UserDto.CompanyCountryEnum[keyof typeof UserDto.CompanyCountryEnum];
